'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const utils_debounce = require('../../../utils/debounce.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const tableWrapper = "_table-wrapper_1wcw1_1";
const table = "_table_1wcw1_1";
const styles = {
	tableWrapper: tableWrapper,
	table: table
};

const Table = ({ scrollable, children, collapse = false, kind = "standard" }) => {
  const [isScrolledHorz, setIsScrolledHorz] = React.useState(false);
  const [isScrolledVert, setIsScrolledVert] = React.useState(false);
  const setScroll = utils_debounce.debounce((target) => {
    const { scrollLeft, scrollTop } = target;
    setIsScrolledHorz(scrollLeft > 0);
    setIsScrolledVert(scrollTop > 0);
  }, 20);
  const onScroll = (e) => {
    setScroll(e.target);
  };
  return React__default.default.createElement(
    "div",
    { className: styles.tableWrapper, "data-scrollable": scrollable ? true : void 0, "data-scrolled-horz": isScrolledHorz ? true : void 0, "data-scrolled-vert": isScrolledVert ? true : void 0, "data-zds": true, onScroll },
    React__default.default.createElement("table", { className: styles.table, "data-collapse": collapse ? true : void 0, "data-kind": kind, "data-zds": true, role: "table" }, children)
  );
};

exports.Table = Table;
//# sourceMappingURL=Table.cjs.js.map
